import { useNavigate, useParams } from "react-router-dom";

import { ITituloFormProps } from "./TituloForm";
import { notification } from "antd";
import { useBuscarMutation } from "@/Services/Financeiro/Titulo/TituloService";
import { useEffect } from "react";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";
import APagarLancamentoForm from "./APagar/lancamento/APagarLancamentoForm";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import AReceberLancamentoForm from "./AReceber/lancamento/AReceberLancamentoForm";

interface ITituloCadastroScreenProps extends ITituloFormProps {
}

export default function TituloCadastroScreen({
    onCancelar,
    onSalvarSucesso,
    codigo : codParam,
    aReceberProps,
    aPagarProps,
    isAReceber,
    ...rest
}:ITituloCadastroScreenProps): JSX.Element {
    const navigate = useNavigate();

    const { codigo : codRotaString } = useParams();
    const codRota = Number.parseInt(codRotaString ?? "");

    const codigo = isNaN(codRota) || codRota <= 0 ? codParam : codRota;
    const isAlteracao = codigo !== undefined && isFinite(codigo) && !isNaN(codigo) && codigo > 0;

    const {
        isPending,
        isSuccess,
        mutate,
        data
    } = useBuscarMutation({
        onSuccess(data, variables, context) {
        },
        onError(error, variables, context) {
            notification.info({
                ...PropriedadesDeNotificacao["Aviso"],
                message: "Não foi possível encontrar o titulo que deseja alterar.",
            });

            onCancelar?.({} as any);
        },
    });

    const tituloSalvo = isPending === false && isSuccess === true ? data : undefined;

    useEffect(() => {
        if (isAlteracao)
        {
            mutate({
                codigo : codigo ?? 0
            });
        }
    }, [codigo, isAlteracao]);

    if (!isAlteracao) return <>
        {
            isAReceber === false && <APagarLancamentoForm 
                initialValues={{
                    titulo : aPagarProps?.defaultValues
                }}
                popular={false}
                onSuccess={(v) => {
                    onSalvarSucesso?.(v?.titulo?.codigo ?? null);
                    (onCancelar ?? ((ev) => navigate(-1)))?.({} as any)
                }}
                onCancelar={() => {
                    if (onCancelar) onCancelar?.({} as any);
                    else navigate(-1);
                }}
            />
        }
        {
            isAReceber === true && <AReceberLancamentoForm
                initialValues={{
                    titulo: aReceberProps?.defaultValues
                }}
                popular={false}
                onSuccess={(v) => {
                    onSalvarSucesso?.(v?.titulo?.codigo ?? null);
                    (onCancelar ?? ((ev) => navigate(-1)))?.({} as any)
                }}
                onCancelar={() => {
                    if (onCancelar) onCancelar?.({} as any);
                    else navigate(-1);
                }}
            />
        }
        {
            isAReceber !== true && isAReceber !== false && <>Informe o tipo de lançamento</>
        }
    </>

    return (
        <TelaCarregamento ativo={isPending}>
            {
                tituloSalvo?.data?.devedor?.tipo === EnumPessoaTipo.EMPRESA && <APagarLancamentoForm 
                    popular={false}
                    initialValues={{
                        titulo : tituloSalvo?.data
                    }}
                    onSuccess={(v) => {
                        onSalvarSucesso?.(v?.titulo?.codigo ?? null);
                        (onCancelar ?? ((ev) => navigate(-1)))?.({} as any)
                    }}
                    onCancelar={() => {
                        if (onCancelar) onCancelar?.({} as any);
                        else navigate(-1);
                    }}
                /> || <AReceberLancamentoForm 
                    popular={false}
                    initialValues={{
                        titulo : tituloSalvo?.data
                    }}
                    onSuccess={(v) => {
                        onSalvarSucesso?.(v?.titulo?.codigo ?? null);
                        (onCancelar ?? ((ev) => navigate(-1)))?.({} as any)
                    }}
                    onCancelar={() => {
                        if (onCancelar) onCancelar?.({} as any);
                        else navigate(-1);
                    }}
                />
            }
        </TelaCarregamento>
    );
}